export const styles = {
  mainWrapper: {
    position: "relative",
    // maxWidth: "150px",
    margin: "0px auto",
  },
  iconWrapper: {
    position: "absolute",
    right: "12px",
    top: "10px",
    zIndex: "1",
  },
  staffUploadIcon: {
    width: "30px",
    height: "30px",
    borderRadius: "100%",
    border: "1px solid #f1f1f1",
    boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.12)",
    background: "#fff",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "350px",
    // borderRadius: "100%",
    border: "4px solid #F8F8F8",
    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    transition: "all 0.2s ease-in-out",
  },
};
